import { render, staticRenderFns } from "./PastDue.vue?vue&type=template&id=5c0892dc&scoped=true"
import script from "./PastDue.vue?vue&type=script&lang=js"
export * from "./PastDue.vue?vue&type=script&lang=js"
import style0 from "./PastDue.vue?vue&type=style&index=0&id=5c0892dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0892dc",
  null
  
)

export default component.exports